import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, message, Space, Descriptions } from "antd";
import { editBusiness } from "../actions/acc_actions";
import { useTranslation } from "react-i18next";

export default function BusinessPreview({ data, refetch }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (data?.config?.contact) {
      form.setFieldsValue({
        config: {
          contact: {
            facebook_tag: data.config.contact.facebook_tag,
            instagram_tag: data.config.contact.instagram_tag,
            twitter_tag: data.config.contact.twitter_tag,
            tiktok_tag: data.config.contact?.tiktok_tag,
            email: data.config.contact.email,
            phone: data.config.contact.phone,
            website: data.config.contact.website,
          },
        },
      });
    }
  }, [data, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await editBusiness(data.urn, data.account_urn, {
        ...values.config.contact,
      });

      message.success(t("business_updated_success"));
      setEditing(false);

      await refetch();
    } catch (error) {
      message.error(t("business_update_failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      title={data.name || t("business_name")}
      extra={
        <Space>
          {editing ? (
            <>
              <Button onClick={() => setEditing(false)}>{t("cancel")}</Button>
              <Button type="primary" onClick={handleSave} loading={loading}>
                {t("save")}
              </Button>
            </>
          ) : (
            <Button type="primary" onClick={() => setEditing(true)}>
              {t("edit")}
            </Button>
          )}
        </Space>
      }
    >
      {editing ? (
        <Form form={form} layout="vertical">
          <Form.Item
            name={["config", "contact", "facebook_tag"]}
            label={t("facebook")}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["config", "contact", "instagram_tag"]}
            label={t("instagram")}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["config", "contact", "twitter_tag"]}
            label={t("twitter")}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["config", "contact", "tiktok_tag"]}
            label={t("tiktok")}
          >
            <Input />
          </Form.Item>
          <Form.Item name={["config", "contact", "email"]} label={t("email")}>
            <Input type="email" />
          </Form.Item>
          <Form.Item name={["config", "contact", "phone"]} label={t("phone")}>
            <Input />
          </Form.Item>
          <Form.Item
            name={["config", "contact", "website"]}
            label={t("website")}
          >
            <Input />
          </Form.Item>
        </Form>
      ) : (
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label={t("facebook")}>
            {data?.config?.contact?.facebook_tag || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("instagram")}>
            {data?.config?.contact?.instagram_tag || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("twitter")}>
            {data?.config?.contact?.twitter_tag || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("tiktok")}>
            {data?.config?.contact?.tiktok_tag || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("email")}>
            {data?.config?.contact?.email || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("phone")}>
            {data?.config?.contact?.phone || t("not_available")}
          </Descriptions.Item>
          <Descriptions.Item label={t("website")}>
            {data?.config?.contact?.website ? (
              <a
                href={`https://${data.config.contact.website}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.config.contact.website}
              </a>
            ) : (
              t("not_available")
            )}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Card>
  );
}
